import React, { useEffect, useState, useRef } from 'react';
import MiniSideBar from '../../components/mini-sidebar';
import useLoader from '../../components/loader/loaderstates';
import Loader from '../../components/loader/loader';
import SecondaryNav from "../../components/seconday-nav";
import { getLoginID } from "../../auth";
// import { FetchPatientsList } from "../../middleware/services/patients";
// import { SaveCreateNotification } from "../../middleware/services/notifications";
import SimpleTable from "../../components/simple-table";
import { FetchPatientsList, FetchFilteredPatientsList } from "../../middleware/services/patients";

import {
    Box,
    Flex,
    Image,
    Text,
    Td,
    Tr,
    CheckboxGroup,
    Checkbox,
    Th,
    Spacer,
    Textarea,
    Divider,
} from "@chakra-ui/react";
import {
    DropdownInput,
    PrimaryButton,
    PrimaryInput,
    SearchBar,
    Toaster,
} from "../../components";
import moment from 'moment';
import { center } from '@antv/g2plot/lib/plots/sankey/sankey';
import { useNavigate } from 'react-router-dom';
import { FetchMedicineViewDetails } from '../../middleware/services/medicines';
import { AssignMedicine } from '../../middleware/services/profile';

const AssignMedicineIndex = () => {
    const { isLoading, showLoader, dismissLoader } = useLoader();
    const { showSuccessToast, showErrorToast } = Toaster();
    const [medicineListData, setMedicineListData] = useState([]);
    const [selectedMedicines, setSelectedMedicines] = useState([]);
    const [selectedMedicineIds, setSelectedMedicinesIds] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const [SearchValueRightTable, setSearchValueRightTable] = useState("");
    const [showmedicines, setShowMedicines] = useState(true);
    const [NotificationType, setNotificationType] = useState("");
    const [title, SetTitle] = useState("");
    const [messagetext, SetMessageText] = useState("");
    const tableRef = useRef();
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const RightTable = [
        { key: "", label: "" },
        { key: "name", label: "Name" },
    ];
    const fetchpaginationData = async (page) => {
        setSearchValue("")
        showLoader();
        try {
            const result = await FetchMedicineViewDetails({
                // "doctorid": getLoginID(),
                "pageno": page,
                "pagesize": 100,
        "type": "catalog"
            });
            //   console.log('CreateNotificationresult: ', result)
            if (result != null) {
                const response = result.data;
                console.log(response, "response of get call of medicines list")
                setMedicineListData(response);
                if (result && result.count === 0 && result.pagesize === 0) {
                    setTotalPages(1);
                } else {
                    setTotalPages(Math.ceil(result.count / result.pagesize));
                }
            } else {
                setMedicineListData([])
                setTotalPages(1);
            }
            dismissLoader();
        } catch (error) {
            console.error("Error in home:", error);
        }
    };

    // const { suppId } = useParams(); // If using react-router
// OR

    useEffect(() => {
        fetchpaginationData(currentPage);
    }, [currentPage]);
    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        const suppId = searchParams.get('suppId');
        // console.log('suppID: ', suppId)
        setSupplierID(suppId)
    }, []);
    const handleNextClick = () => {
        setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
        fetchpaginationData(currentPage + 1);
    };

    const handlePreviousClick = () => {
        setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
        fetchpaginationData(currentPage - 1);
    };
    const searchpatient = async (e) => {
        const value = e.target.value;
        if (e.key === "Enter") {
            showLoader();
            try {
                const result = await FetchMedicineViewDetails({
                    // "loginid": getLoginID(),
                    "searchtext": value,
                    "pageno": 1,
                    "pagesize": 100,
        "type": "catalog"
                });

                if (result != null) {
                    const response = result.data;
                console.log(response, "response of search result of medicines list")
                    setMedicineListData(response);
                    if (result && result.count === 0 && result.pagesize === 0) {
                        setTotalPages(1);
                    } else {
                        setTotalPages(Math.ceil(result.count / result.pagesize));
                    }
                } else {
                    setMedicineListData([])
                    setTotalPages(1);
                }
                dismissLoader();
            } catch (error) {
                console.error("Error in home:", error);
            }
        }
    };
    const closeSearchBar = () => {
        setSearchValue("")
        fetchpaginationData(1)
    }
    // const handleCheckboxChange = (doctor) => {
    //     console.log('doctor: hancleCheckboxChange', doctor)
    //     // setSelectedMedicines([...selectedMedicines, doctor]);
    //     if (!selectedMedicineIds.includes(doctor.doctorid)) {
    //         setSelectedMedicinesIds([...selectedMedicineIds, doctor.doctorid]);
    //         setSelectedMedicines([...selectedMedicines, doctor]);
    //     }
    // };
    // const handleRemoveMedicine = (doctor) => {
    //     // setSelectedMedicines(selectedMedicines.filter(p => p !== doctor));
    //     setSelectedMedicinesIds(selectedMedicineIds.filter(id => id !== doctor.doctorid));
    //     setSelectedMedicines(selectedMedicines.filter(p => p.doctorid !== doctor.doctorid));
    // };

    const handleCheckboxChange = (medicine) => {
        console.log('medicine: handleCheckboxChange', medicine);
        if (!selectedMedicineIds.includes(medicine.id)) {  // Use medicine.id instead of doctorid
            setSelectedMedicinesIds([...selectedMedicineIds, medicine.id]);
            setSelectedMedicines([...selectedMedicines, medicine]);
        }
    };
    
    const handleRemoveMedicine = (medicine) => {
        setSelectedMedicinesIds(selectedMedicineIds.filter(id => id !== medicine.id));
        setSelectedMedicines(selectedMedicines.filter(p => p.id !== medicine.id));
    };

    const [supplierId, setSupplierID] = useState("");
    const handleAssignMedicine = async () => {
        const medicinesArray = selectedMedicines.map(medicine => ({
            catalogid: medicine.id, 
            // isactive: medicine.iscurrentmedicine,
            isactive: 1,
        }));

        const assignInput = {
            "supplierid": supplierId,
            "doctorid": getLoginID(),
            "medicines": medicinesArray
        };
        showLoader();
        try{
            const result = await AssignMedicine(assignInput);
            if(result && result.output.result == "success"){
                navigate('/supplier')
                showSuccessToast("Medicined assigned successfully")
                setSelectedMedicines([]);
                setSelectedMedicinesIds([]);
            }
            dismissLoader()

        } catch(err) {
            console.log("Something went wrong!", err)
        }
    }
    const savePatientList = () => {
        if (selectedMedicines.length > 0) {
            setShowMedicines(false);
        } else {
            showErrorToast("Please select any patient to proceed")
        }

    }
    const CreateNotification = async () => {
        if (NotificationType == "") {
            showErrorToast("Please select the type")
        }
        else if (title == "") {
            showErrorToast("Please provide the title")
        }
        else if (messagetext == "") {
            showErrorToast("Please provide the notification text")
        }
        else {
            let input = {
                "title": title,
                "message": messagetext,
        "type": "catalog",
                // "notificationtype":NotificationType,
                "notificationtype": 'push notification',
                "notificationfor": NotificationType,
                userdetails: selectedMedicines && selectedMedicines.map((step) => ({
                    fcmtoken: step.fcmtoken,
                    usertype: "patient",
                    userid: step.patientid,
                }))
            }
            // console.log(input);
            showLoader();
            try {
                const result = await FetchMedicineViewDetails(input);

                if (result != null) {
                    navigate("/notifications")
                }
                dismissLoader();
            } catch (error) {
                console.error("Error in home:", error);
                dismissLoader();
            }
        }
    }
    const handletypechange = (value) => {
        if (value == "Vitals") {
            setNotificationType("vitals")
        } else if (value == "Condition") {
            setNotificationType("condition")
        } else if (value == "Surgeries") {
            setNotificationType("surgeries")
        } else if (value == "Medication") {
            setNotificationType("medication")
        } else if (value == "Allergies") {
            setNotificationType("allergies")
        } else if (value == "Others") {
            setNotificationType("others")
        }

    }
    const backFunction = () => {
        if (showmedicines == true) {
            navigate("/supplier")
        } else {
            setShowMedicines(true);
        }

    }
    return (
        <Box w="100%">
            <Flex>
                <Box w="6rem">
                    <MiniSideBar />
                </Box>
                {isLoading && <Loader />}
                <Box w="100%">
                    <SecondaryNav
                        //customHeader="Create Notification" 
                        withBack={"Assign Medicines"}
                        goBack={backFunction}
                    />
                    {showmedicines &&
                        <Flex w="100%">
                            {/* left container start */}
                            <Box w="60%">
                                <Box
                                    gap="10px"
                                    w="100%"
                                    p="1.5rem"
                                    display="flex"
                                    flexDirection="column"
                                    borderRight="1px solid #E6E7E9"
                                >
                                    <Text fontSize="1.25rem" fontWeight="700">
                                        Select Medicines
                                    </Text>
                                    <SearchBar
                                        passInputPlace="Search"
                                        onKeyPress={searchpatient}
                                        onChange={(e) => setSearchValue(e.target.value)}
                                        value={searchValue}
                                        iconSrc="/assets/imgs/remove-icon.png"
                                        handleClick={closeSearchBar}
                                    />
                                    {/* <PrimaryButton
                                    buttonText="Reset"
                                    id="resetButton"
                                    variant="grayBtnFull"
                                    btnStyle={{ color: "#AA2F27" }}
                                    onClick={()=> fetchpaginationData(1)}
                                /> */}
                                </Box>
                                <Box>
                                    <Box border="1px solid #E6E7E9" ref={tableRef}>
                                        <SimpleTable
                                            isTh={false}
                                            className="tableContainer"
                                            isDataPresent={true}
                                            ref={tableRef}
                                            footerStyle={{ pos: "sticky", bottom: "-1px", boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px" }}
                                            tableStyle={{
                                                maxH: "calc(100vh - 190px)",
                                                h: "calc(100vh - 270px)",
                                                overflowY: "auto",
                                                tableLayout: "fixed",
                                                width: "100%",
                                            }}
                                            tableHeaders={
                                                <Tr>
                                                    <Th fontSize="0.87rem" fontWeight="500"></Th>
                                                    <Th fontSize="0.87rem" fontWeight="500">Medicine Name</Th>
                                                    <Th fontSize="0.87rem" fontWeight="500">Composition</Th>
                                                    <Th fontSize="0.87rem" fontWeight="500">Type</Th>
                                                </Tr>
                                            }
                                            tableBody={
                                                <>
                                                    {medicineListData && medicineListData.length > 0 ? (
                                                        medicineListData
                                                            // .filter(step =>
                                                            //     step.fullname
                                                            //         ?.toLowerCase()
                                                            //         .includes(searchValue.toLowerCase())
                                                            // )
                                                            .map((step, index) => (
                                                                <Tr w="100%" key={index}>
                                                                    <Td w="20px" pr="0">
                                                                        {/* <CheckboxGroup colorScheme="green"
                                                                        > */}
                                                                            <Checkbox
                                                                            colorScheme="gray"
                                                                            iconColor="white"
                                                                                value={step.id}
                                                                                // isChecked={selectedMedicines.includes(step)}
                                                                                isChecked={selectedMedicineIds.includes(step.id)}
                                                                                // isDisabled={selectedMedicines.includes(step)}
                                                                                // onChange={() => handleCheckboxChange(step)}
                                                                                onChange={() =>
                                                                                    selectedMedicineIds.includes(step.id)
                                                                                        ? handleRemoveMedicine(step) 
                                                                                        : handleCheckboxChange(step) 
                                                                                }
                                                                            ></Checkbox>
                                                                        {/* </CheckboxGroup> */}
                                                                    </Td>
                                                                    <Td>
                                                                        <Box
                                                                            w="100%"
                                                                            display="flex"
                                                                            gap="0.5rem"
                                                                            alignItems="center"
                                                                        >
                                                                            <Box w="80%" maxW="8rem" isTruncated>
                                                                                <Text
                                                                                    className="textOverflow"
                                                                                    fontSize=".875rem"
                                                                                    fontWeight="600"
                                                                                >
                                                                                    {step.medicinename ? step.medicinename : "-"}
                                                                                </Text>
                                                                            </Box>
                                                                        </Box>
                                                                    </Td>
                                                                    <Td>
                                                                        <Text
                                                                            className="textOverflow"
                                                                            width="165px"
                                                                            fontSize=".875rem"
                                                                            fontWeight="500"
                                                                            isTruncated
                                                                        >
                                                                            {step.chemicalcomposition ? step.chemicalcomposition : "-"}
                                                                        </Text>
                                                                    </Td>
                                                                    <Td>
                                                                        <Text
                                                                            fontSize=".75rem"
                                                                            fontWeight="600"
                                                                            isTruncated
                                                                        >
                                                                            {step.medicinetype ? step.medicinetype : "-"}
                                                                        </Text>
                                                                    </Td>
                                                                    {/* <Td maxW="130px">
                                                                    <Text fontSize=".875rem" fontWeight="500">
                                                                        {step.createddate ? formatDate(step.createddate) : "-"}
                                                                    </Text>
                                                                </Td> */}
                                                                </Tr>
                                                            ))
                                                    ) : (
                                                        <Tr>
                                                            <Td colSpan={5} textAlign="center">
                                                                No medicines available.
                                                            </Td>
                                                        </Tr>
                                                    )}
                                                </>
                                            }

                                        />
                                    </Box>
                                </Box>
                            </Box>
                            {/* left container end */}

                            {/* right container start */}
                            <Box w="40%">
                                <Box
                                    gap="10px"
                                    w="100%"
                                    p="1.5rem"
                                    display="flex"
                                    flexDirection="column"
                                >
                                    <Text fontSize="1.25rem" fontWeight="700">
                                        Selected Medicines
                                    </Text>
                                    <SearchBar
                                        passInputPlace="Search"
                                        onChange={(e) => setSearchValueRightTable(e.target.value)}
                                    />
                                </Box>
                                <Box>
                                    <Box border="1px solid #E6E7E9" ref={tableRef}>
                                        <SimpleTable
                                            headers={RightTable}
                                            className="tableContainer"
                                            isDataPresent={selectedMedicines.length > 0}
                                            ref={tableRef}
                                            footerStyle={{
                                                pos: "sticky",
                                                bottom: "-1px",
                                                boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
                                            }}
                                            tableStyle={{
                                                maxH: "calc(100vh - 190px)",
                                                h: "calc(100vh - 270px)",
                                                overflowY: "auto",
                                                tableLayout: "fixed",
                                                width: "100%",
                                            }}
                                            tableBody={
                                                <>
                                                    {selectedMedicines && selectedMedicines.length > 0 ? (
                                                        selectedMedicines
                                                            .filter(step =>
                                                                step.medicinename
                                                                    ?.toLowerCase()
                                                                    .includes(SearchValueRightTable.toLowerCase())
                                                            ).length > 0 ? (
                                                            selectedMedicines
                                                                .filter(step =>
                                                                    step.medicinename
                                                                        ?.toLowerCase()
                                                                        .includes(SearchValueRightTable.toLowerCase())
                                                                )
                                                                .map((step, index) => (
                                                                    <Tr w="100%" key={index}>
                                                                        <Td w="20px" pr="0">
                                                                            <CheckboxGroup colorScheme="green">
                                                                                <Checkbox
                                                                                    // value={step.id}
                                                                                    isChecked={true}
                                                                                    onChange={() => handleRemoveMedicine(step)}
                                                                                ></Checkbox>
                                                                            </CheckboxGroup>
                                                                        </Td>
                                                                        <Td>
                                                                            <Box
                                                                                w="100%"
                                                                                display="flex"
                                                                                gap="0.5rem"
                                                                                alignItems="center"
                                                                            >
                                                                                <Box w="80%" maxW="20rem" isTruncated>
                                                                                    <Text
                                                                                        className="textOverflow"
                                                                                        fontSize=".875rem"
                                                                                        fontWeight="600"
                                                                                    >
                                                                                        {step.medicinename ? step.medicinename : "-"}
                                                                                    </Text>
                                                                                    <Text fontSize=".75rem">
                                                                                        {step.chemicalcomposition ? step.chemicalcomposition : "-"}
                                                                                    </Text>
                                                                                </Box>
                                                                            </Box>
                                                                        </Td>
                                                                    </Tr>
                                                                ))
                                                        ) : (
                                                            <Tr>
                                                                <Td colSpan={5} textAlign="center">
                                                                    No match available.
                                                                </Td>
                                                            </Tr>
                                                        )
                                                    ) : (
                                                        <Tr>
                                                            <Td colSpan={5} textAlign="center">
                                                                No medicines selected.
                                                            </Td>
                                                        </Tr>
                                                    )}
                                                </>
                                            }
                                        />

                                    </Box>
                                </Box>
                            </Box>
                            {/* right container end */}
                        </Flex>
                    }
                    {!showmedicines &&
                        <Flex w="100%" justifyContent="center" mt='1.5rem'>
                            <Box w="60%" p="1.5rem" border="1px solid #E6E7E9" borderRadius='10px' bg='white'>
                                <Box
                                    gap="10px"
                                    w="100%"
                                    // pl='0'
                                    // pb='0'
                                    display="flex"
                                    alignItems='center'
                                >
                                    <Image
                                        src="/assets/imgs/arrow_back.png"
                                        w="15px" mr="5px"
                                        onClick={backFunction}
                                        cursor='pointer'
                                    />
                                    <Text fontSize="1.25rem" fontWeight="700">
                                        Notification Details
                                    </Text>
                                </Box>
                                <Divider my='0.75rem' />
                                <Box display='flex' w='100%'>
                                    <DropdownInput
                                        variant="leftSide"
                                        dropDownPlace="Type of notification*"
                                        options={['Vitals', 'Condition', 'Surgeries', 'Medication', 'Allergies', 'Others']}
                                        readOnly={true}
                                        id="Notification Type"
                                        onClick={handletypechange}
                                        //defaultOption={NotificationType}
                                        menuList={{ pos: "absolute", right: "-45px", minW: "115px" }}
                                        inputStyleCss={{ w: "40%" }}
                                    />
                                    <PrimaryInput
                                        variant="rightSide"
                                        inputPlace="Title*"
                                        id="title"
                                        onChange={(e) => SetTitle(e.target.value)}
                                        inputValue={title}
                                    />
                                </Box>

                                <Box w='100%' mt='1rem'>
                                    <Text fontSize="1rem" mb='0.5rem' fontWeight="500">Message<sup>*</sup></Text>
                                    <Textarea placeholder='Type your Message*'
                                        onChange={(e) => SetMessageText(e.target.value)}
                                        defaultValue={messagetext}
                                        sx={{ h: "150px", _hover: { outline: "none", } }}>
                                    </Textarea>
                                </Box>
                            </Box>
                        </Flex>
                    }
                    {/* {showmedicines && (  previous code */}
                    {showmedicines && medicineListData && medicineListData.length > 0 && (
                        <Flex w="100%" gap='0.5rem' px="1.5rem" pt="1rem" justifyContent="space-between" alignItems="center">
                            <Box
                                display="flex"
                                alignItems="center"
                                justifyContent='space-between'
                                w='60%'
                            >
                                <Box
                                    as="button"
                                    onClick={handlePreviousClick}
                                    disabled={currentPage === 1}
                                    visibility={currentPage === 1 ? "hidden" : "visible"}
                                    p="0.5rem 0.75rem"
                                    border="0.0625rem solid #E6E7E9"
                                    borderRadius="0.75rem"
                                    fontSize="1rem"
                                    fontWeight="500"
                                    mr="1rem"
                                >
                                    Previous
                                </Box>
                                <Text textAlign="center" fontSize=".875rem" fontWeight="600">
                                    Page {currentPage} of {totalPages}
                                </Text>
                                <Box
                                    as="button"
                                    p="0.5rem 0.75rem"
                                    ml="1rem"
                                    border="0.0625rem solid #E6E7E9"
                                    borderRadius="0.75rem"
                                    onClick={handleNextClick}
                                    disabled={currentPage === totalPages}
                                    visibility={currentPage === totalPages ? "hidden" : "visible"}
                                    fontSize="1rem"
                                    fontWeight="500"
                                >
                                    Next
                                </Box>
                            </Box>

                            <Box w='40%' textAlign='right'>
                                <PrimaryButton
                                    buttonText="Next"
                                    variant="mdBtn"
                                    btnStyle={{ w: "200px" }}
                                    onClick={handleAssignMedicine}
                                />
                            </Box>
                        </Flex>
                    )}


                    {!showmedicines &&
                        <Box w='100%' pos='fixed' bottom='0' bg='white' borderTop="1px solid #E6E7E9">
                            <PrimaryButton
                                buttonText="Create"
                                variant="mdBtn"
                                btnStyle={{ w: "200px", my: "1rem", left: "75%" }}
                                onClick={CreateNotification}
                            />
                        </Box>
                    }
                </Box>
            </Flex>
        </Box>
    );
}

export default AssignMedicineIndex;
